import tw, { styled } from 'twin.macro';

const MarkdownHeading1 = styled.h1`
  ${tw`py-3 border-0 border-b  border-solid`}

  .message-type-markdown & {
    ${tw`py-0 border-b-0 m-0`}
  }
`;

export default MarkdownHeading1;
